import PropTypes from 'prop-types';
// material
import { experimentalStyled as styled } from '@mui/material/styles';
import { AppBar, IconButton, Toolbar } from '@mui/material';
// icons
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
// components
import { MHidden } from '../../components/@material-extend';
import { useLocation } from 'react-router';

// ----------------------------------------------------------------------

const APPBAR_MOBILE = 48;
const APPBAR_DESKTOP = 64;

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isCertificationPage',
})(({ isCertificationPage }) => ({
  backgroundColor: isCertificationPage ? '#ffffff' : 'transparent',
  boxShadow: 'none',
}));

const ToolbarStyle = styled(Toolbar, {
  shouldForwardProp: (prop) => prop !== 'isCertificationPage',
})(({ isCertificationPage }) => ({
  minHeight: APPBAR_MOBILE,
  '@media (min-width:1200px)': {
    minHeight: isCertificationPage ? 0 : APPBAR_DESKTOP,
    padding: isCertificationPage ? 0 : '0px 40px',
  },
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar = () => null }) {
  const { pathname } = useLocation();

  // Hide the navbar for user settings page
  if (pathname === '/workbench/user/settings') {
    return null;
  }

  // Hide the navbar on the User Management tool. The page uses
  // UnifiedHeader for its own sticky header + HeaderIcons, and the empty
  // AppBar here otherwise produces a ~64px empty band above it.
  if (pathname.startsWith('/user-management')) {
    return null;
  }

  const isCertificationPage = /\/workbench\/[^/]+\/\d+(\/|$)/.test(pathname);

  return (
    <RootStyle isCertificationPage={isCertificationPage}>
      <ToolbarStyle isCertificationPage={isCertificationPage}>
        <MHidden width="lgUp">
          <IconButton
            onClick={onOpenSidebar}
            sx={{
              mr: 1,
              color: 'text.primary',
              pointerEvents: 'initial',
              backgroundColor: 'white !important',
            }}
            size="large"
          >
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>
      </ToolbarStyle>
    </RootStyle>
  );
}
